// src/utils/imageToBase64.ts
export const imageToBase64 = async (imagePath: string): Promise<string> => {
  return new Promise(async (resolve) => {
    const _url = `${
      process.env.PUBLIC_ASSETS_URL || process.env.STORYBOOK_PUBLIC_ASSETS_URL
    }/cyber-resilience-assessment/${imagePath}`;
    const response = await fetch(_url);
    const imageBlob = await response.blob();

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      if (base64) resolve(base64);
    };

    reader.readAsDataURL(imageBlob);
  });
};
